import { createElementBlock as t, openBlock as o, createElementVNode as n } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(c, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    n("path", {
      fill: "#05CA79",
      d: "M17.5 2.675V10.5a7 7 0 1 1-7-7h.778v4.667H10.5a2.333 2.333 0 1 0 2.333 2.333V.263C12.083.093 11.303 0 10.5 0 4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5c0-3.109-1.352-5.901-3.5-7.824"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
